<template>
  <v-container class="fill-height">
    <v-row justify="center">
      <v-progress-circular
        indeterminate
        color="primary"
        v-if="loading"
      ></v-progress-circular>

      <v-col cols="10" sm="9" md="11" xl="6" class="pa-0" v-else>
        <v-form ref="form">
          <ContactInfo
            v-if="showContactInfo"
            v-bind:locale="locale"
            v-model="result.contactInfo"
            v-bind:part="part"
            v-bind:type="type"
            @part="setPart"
          />

          <router-view
            v-else
            v-model="result[skill]"
            v-bind:level="level"
            v-bind:skill="assessment.assessment[skill]"
            v-bind:locale="locale"
            v-bind:type="type"
            ref="skillRef"
          ></router-view>
        </v-form>
      </v-col>
    </v-row>

    <v-row v-if="this.type" justify="center" class="action-buttons-container">
      <v-col cols="10" sm="8" md="6" xl="4">
        <v-row justify="space-between">
          <div
            v-for="button in controllButtons[type][locale]"
            :key="button.uid"
          >
            <v-btn
              v-if="button.type === 'prev'"
              color="primary"
              @click="Prev">{{ button.text }}</v-btn>
            <v-btn
              v-if="button.type === 'next' && type !=='D3'"
              color="primary"
              @click="Next"
              >{{ button.text }}</v-btn
            >
            <v-btn
		    v-if="button.type === 'next' && (!level || level === 'c2') && type ==='D3'"
              color="primary"
              @click="Next"
              >{{ button.text }}</v-btn
            >
            <v-btn
              v-if="button.type === 'nextLevel' && level && type ==='D3' && level !== 'c2'"
              color="primary"
              @click="Next"
	      >{{ button.text }}</v-btn>
            <v-btn
              v-if="button.type === 'nextSkill' && level && type ==='D3' && skill != 'lasa'"
              color="primary"
              @click="NextSkill"
	      >{{ button.text }}</v-btn>
        <v-btn
              v-if="button.type === 'finish' && type ==='D3' && skill == 'lasa' && levelList.includes(level)"
              color="primary"
              @click="NextSkill"
	      >{{ button.text }}</v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="continueDialog" v-if="type" persistent max-width="525">
      <template>
        <v-card>
          <v-card-title>
            {{ continueDialogText[type][part][locale].title }}
          </v-card-title>
          <v-card-text>
            {{ continueDialogText[type][part][locale].text }}
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="
                () => {
                  this.continueDialog = false;
                  this.submitDialog = true;
                }
              "
              color="primary"
              text
            >
              {{ continueDialogText[type][part][locale].submitBtn }}
            </v-btn>
            <v-btn
              @click="
                () => {
                  this.continue = true;
                  this.continueDialog = false;
                  this.NextSkill();
                }
              "
              color="primary"
              text
            >
              {{ continueDialogText[type][part][locale].continueBtn }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="submitDialog" v-if="type" persistent max-width="525">
      <template>
        <v-card>
		<v-card-title v-if="!downloading">
            {{ submitDialogText[type][locale].title }}
          </v-card-title>
	  <v-card-title v-else>
		  {{submitDialogText[type][locale].downloadingTitle}}
	  </v-card-title>
          <v-card-text v-if="!downloading">
            <v-row>
              <v-col>
                <p style="white-space: pre-line;" class="black--text">
                  {{ submitDialogText[type][locale].text }}
                </p>
              </v-col>
            </v-row>
            <v-row justify="start">
              <v-col cols="12">
                <v-checkbox
                  v-if="false"
                  v-model="mail"
                  disabled
                  :label="submitDialogText[type][locale].mail"
                ></v-checkbox>
                <v-checkbox
                  v-if="false"
                  v-model="dl"
                  :label="submitDialogText[type][locale].dl"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else>
            <v-row justify="center" align="center">
              <v-col cols="2">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p>
                  {{ downloadingText[type][locale] }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-spacer></v-spacer>
          <v-card-actions v-if="!downloading">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="submit">{{
              submitDialogText[type][locale].sub
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-container>
</template>

<script>
import { db, /*auth, functions*/ } from "@/common/firebase.js";
import ContactInfo from "@/components/assessment/components/ContactInfo.vue";
import ControllButtonText from "@/components/assessment/components/ControllButtonText.js";
import ResultTemplate from "@/components/assessment/components/ResultTemplate.js";

import apiCall from "@/api";
import { FINISH_ASSESSMENT } from "@/api/endpoints";
/* 
	abandon all hope ye who enter here, 700+ lines of hell
	
	Denna view är ohållbar och bör göras om. För enkelhetens skull skriver jag lite här hur denna view fungerar.
	Först finns det ett antal dialoger dessa borde flyttas över till separata komponenter i framtiden då data delen är omöjlig att jobba med som det ser ut nu.

	De två viktiga funktionerna är next() och nextSkill(). next kollar resultatet om resultatet är över en threshold skickar den till nästa nivå om resultatet är under skickar den till nästa skill.

*/
export default {
  name: "Assessment",
  props: {
    user: Object,
    tool: String
  },
  components: {
    ContactInfo
  },
  data() {
    return {
      levelList: ["a1", "a2", "b1", "b2", "c1", "c2"],
      downloadingText: {
        D1: {
          sv:
            "Stort tack för att du använder One&All Agile Communication Tool för att bedöma språk och kommunikation!",
          en:
            "Many thanks for using One&All Agile Communication Tool for assessing languages and communication!",
          ar:
            "أداة التواصل لتقييم لغتك وقدرتك على التواصل ONE&ALL AGILE COMMUNICATION TOOL شكرا جزيلا على قيامك باستخدام"
        },
        D3: {
          sv:
            "Tack! Era svar har skickats in. Språkprofilen skapas nu. Vänta kvar några sekunder!",
          en:
            "Many thanks for using One&All Agile Communication Tool for assessing languages and communication!",
          ar:
            "أداة التواصل لتقييم لغتك وقدرتك على التواصل ONE&ALL AGILE COMMUNICATION TOOL شكرا جزيلا على قيامك باستخدام"
        }
      },
      downloading: false,
      selectType: false,
      dl: true,
      mail: false,
      improvements: {},
      type: this.tool,
      part: "both",
      submitDialog: false,
      submitDialogText: {
        D1: {
          sv: {
            title: "Skicka och ladda ner",
            text:
              "Vänligen skicka in och vänta några sekunder här.",
            dl: "Ladda ner resultat direkt",
            mail: "Få direkt via mail",
            sub: "Skicka in",
	    downloadingTitle: "Laddar ner"
          },
          en: {
            title: "Send and download",
            text:
              "Please send and then wait a few seconds here.",
            dl: "Ladda ner resultat direkt",
            mail: "Få direkt via mail",
            sub: "Send",
	    downloadingTitle: "Downloading"
          },
          ar: {
            title: "أرسل وقم بتنزيل المعلومات",
            text:
              ".رجاء انتظر بضعة ثوان هنا",
            dl: ".بعد لحظات ستظهر وثيقة بي دي اف على شاشتك يتبين منها نتيجتك",
            mail: "Få direkt via mail",
            sub: "أرسل",
	    downloadingTitle: "Downloading"
          }
        },
        D3: {
          sv: {
            title: "Skicka in för att få språkprofilen!",
            text:
              "Ni kommer att kunna se och skriva ut profilen för tjänsten när ni loggar in på er profil, Markera nedan om ni även vill ladda ner resultatet direkt.",
            dl: "Ladda ner resultat direkt",
            mail: "Få direkt via mail",
            sub: "Skicka in och Avsluta",
	    downloadingTitle: "Laddar ner"
          },
          en: {
            title: "Send to get the language profile! ",
            text:
              "You will be able to save and print the profile.",
            dl: "Ladda ner resultat direkt",
            mail: "Få direkt via mail",
            sub: "Send and finish!",
	    downloadingTitle: "Downloading"
          },
          ar: {
            title: "Send to get the language profile! ",
            text:
              "You will be able to save and print the profile.",
            dl: "Ladda ner resultat direkt",
            mail: "Få direkt via mail",
            sub: "Send and finish!",
	    downloadingTitle: "Downloading"
          }
        }
      },
      loading: true,
      controllButtons: ControllButtonText,
      continueDialog: false,
      continue: false,
      continueDialogText: {
        D1: {
          oral: {
            sv: {
              text:
                "Du är klar med bedömningen av din muntliga kommunikation. Välj om du vill FORTSÄTTA för att bedöma din skriftliga kommunikationen eller AVSLUTA.",
              title: "Toppen!",
              submitBtn: "Avsluta",
              continueBtn: "Fortsätt"
            },
            en: {
              text:
                "You have completed the assessment of your oral communication. Choose CONTINUE to assess also your written communication or FINISH.",
              title: "Great!",
              submitBtn: "Finish",
              continueBtn: "Continue"
            },
            ar: {
              text:
                "انتهبت الآن من التقييم المتعلق بقدرتك على التواصل الشفوي اختر استمرار لتقييم قدرتك على التواصل الخطي أو أنقر على إنهاء",
              title: "!ممتاز",
              submitBtn: "انهاء",
              continueBtn: "استمرار"
            }
          },
          writing: {
            sv: {
              text:
                "Du är klar med bedömningen av din skriftliga kommunikation. Välj om du vill fortsätta till den muntliga kommunikationen eller avsluta.",
              title: "Toppen!",
              submitBtn: "Avsluta",
              continueBtn: "Fortsätt"
            },
            en: {
              text:
                "You have completed the assessment of your written communication. Choose CONTINUE to assess also your oral communication or FINISH.",
              title: "Great!",
              submitBtn: "Finish",
              continueBtn: "Continue"
            },
            ar: {
              text: "انتهبت الآن من التقييم المتعلق بقدرتك على التواصل الخطي اختر استمرار لتقييم قدرتك على التواصل الشفوي أو أنقر على انهاء",
              title: "!ممتاز",
              submitBtn: "انهاء",
              continueBtn: "استمرار"
            }
          },
          both: {
            sv: {
              text:
                "Toppen! Ni är klara med de första färdigheterna. Välj om ni vill fortsätta till de skriftliga färdigheterna eller avsluta.",
              title:
                "Vill ni fortsätta med andra delen av bedömningen, eller skicka in?",
              submitBtn: "Avsluta",
              continueBtn: "Fortsätt"
            },
            en: {
              text:
                "You have completed the assessment of written communication. Choose if you want to CONTINUE to assess the oral communication or FINISH.",
              title: "",
              submitBtn: "Finish",
              continueBtn: "Continue"
            },
            ar: {
              text:
                "ممتاز! انتهبت الآن من التقييم المتعلق بقدرتك على التواصل الخطي اختر استمرار لتقييم قدرتك على التواصل الشفوي أو أنقر على انهاء",
              title: "",
              submitBtn: "انهاء",
              continueBtn: "استمرار"
            }
          }
        },
        D3: {
          oral: {
            sv: {
              text:
                "Toppen! Ni är klara med de första färdigheterna. Välj om ni vill fortsätta till de skriftliga färdigheterna eller avsluta.",
              title:
                "Vill ni fortsätta med andra delen av bedömningen, eller skicka in?",
              submitBtn: "Avsluta",
              continueBtn: "Fortsätt"
            },
            en: {
              text:
                "You have completed the assessment of written communication. Choose if you want to CONTINUE to assess the oral communication or FINISH.",
              title: "",
              submitBtn: "Finish",
              continueBtn: "Continue"
            },
            ar: {
              text:
                "ممتاز! انتهبت الآن من التقييم المتعلق بقدرتك على التواصل الخطي اختر استمرار لتقييم قدرتك على التواصل الشفوي أو أنقر على انهاء",
              title: "",
              submitBtn: "انهاء",
              continueBtn: "استمرار"
            }
          },
          writing: {
            sv: {
              text:
                "Toppen! Ni är klara med de första färdigheterna. Välj om ni vill fortsätta till de skriftliga färdigheterna eller avsluta.",
              title:
                "Vill ni fortsätta med andra delen av bedömningen, eller skicka in?",
              submitBtn: "Avsluta",
              continueBtn: "Fortsätt"
            },
            en: {
              text:
                "You have completed the assessment of written communication. Choose if you want to CONTINUE to assess the oral communication or FINISH.",
              title: "",
              submitBtn: "Finish",
              continueBtn: "Continue"
            },
            ar: {
              text:
                "ممتاز! انتهبت الآن من التقييم المتعلق بقدرتك على التواصل الخطي اختر استمرار لتقييم قدرتك على التواصل الشفوي أو أنقر على انهاء",
              title: "",
              submitBtn: "انهاء",
              continueBtn: "استمرار"
            }
          },
          both: {
            sv: {
              text:
                "Toppen! Ni är klara med de första färdigheterna. Välj om ni vill fortsätta till de skriftliga färdigheterna eller avsluta.",
              title:
                "Vill ni fortsätta med andra delen av bedömningen, eller skicka in?",
              submitBtn: "Avsluta",
              continueBtn: "Fortsätt"
            },
            en: {
              text:
                "You have completed the assessment of written communication. Choose if you want to CONTINUE to assess the oral communication or FINISH.",
              title: "",
              submitBtn: "Finish",
              continueBtn: "Continue"
            },
            ar: {
              text:
                "ممتاز! انتهبت الآن من التقييم المتعلق بقدرتك على التواصل الخطي اختر استمرار لتقييم قدرتك على التواصل الشفوي أو أنقر على انهاء",
              title: "",
              submitBtn: "انهاء",
              continueBtn: "استمرار"
            }
          }
        }
      },
      tooHigh: {
        D1: {
          sv:
            "Du har troligen bedömt din nivå för denna färdighet för högt. Klicka på knappen TILLBAKA och markera en lägre nivå att starta bedömningen från.",
          en:
            "You have probably assessed your level of this skill too high. Please, click the button BACK, mark a lower approximate level and start your assessment from there.",
          ar:
            ".من المحتمل أن تكون قد قيّمت مستواك بشكل زائد عن الحد. انقر على الزر عودة وضع علامة على مستوى أقل للانطلاق منه"
        },
        D3: {
          sv:
            "Du har troligen bedömt din nivå för denna färdighet för högt. Klicka på knappen TILLBAKA och markera en lägre nivå att starta bedömningen från.",
          en:
            "You have probably assessed the level of this skill too high. Please, click the button BACK, mark a lower approximate level and start your assessment from there. ",
          ar:
            ".من المحتمل أن تكون قد قيّمت مستواك بشكل زائد عن الحد. انقر على الزر عودة وضع علامة على مستوى أقل للانطلاق منه"
        }
      },
	    result: ResultTemplate(),
      assessment: {}
    };
  },
  computed: {
    fullPath: function() {
      return this.$route.fullPath;
    },
    skill: function() {
      return this.$route.params.skill;
    },
    level: function() {
      return this.$route.params.level;
    },
    locale: function() {
      return this.$store.getters.GET_LOCALE.value;
    },
    availableAssessments: function() {
      return this.$store.getters["user/GET_AVAILABLE_ASSESSMENT"];
    },
    levelResult: function() {
      return this.result[this.skill][this.level].reduce((acc, curr) => {
        if (curr === "Ja" || curr === "JaLång") {
          return (acc += 1);
        } else {
          return acc;
        }
      }, 0);
    },
    showContactInfo: function() {
      if (
        this.fullPath === "/assessment/D1" ||
        this.fullPath === "/assessment/D3"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    Next() {
      if (this.validate()) {
        const basePath = "/assessment/" + this.type;
        if (this.fullPath === basePath) {
          if (this.part === "oral" || this.part === "both") {
            this.$router.push(basePath + "/" + "samtala");
            return;
          } else {
            this.$router.push(basePath + "/" + "skriva");
            return;
          }
        } else if (this.fullPath === basePath + "/" + this.skill) {
          this.$router.push(
            this.fullPath + "/" + this.result[this.skill].rough
          );
          return;
        } else if (
          this.fullPath ===
          basePath + "/" + this.skill + "/" + this.level
        ) {
          const levels = ["a1", "a2", "b1", "b2", "c1", "c2"];
          if (this.type === "D1") {
            if (this.levelResult < 4) {
              this.NextSkill();
            } else {
              if (levels[levels.indexOf(this.level) + 1])
                this.$router.push(
                  basePath +
                    "/" +
                    this.skill +
                    "/" +
                    levels[levels.indexOf(this.level) + 1]
                );
              else {
                this.NextSkill();
              }
            }
          } else {
            if (
              this.levelResult < 2 &&
              this.result[this.skill].rough === this.level &&
              levels.indexOf(this.result[this.skill].rough) > 0
            ) {
		    // remove 
              window.alert(this.tooHigh[this.type][this.locale]);
	      this.result[this.skill][this.level] = [];

            } else {
              if (levels[levels.indexOf(this.level) + 1])
                this.$router.push(
                  basePath +
                    "/" +
                    this.skill +
                    "/" +
                    levels[levels.indexOf(this.level) + 1]
                );
              else {
                this.NextSkill();
              }
            }
          }
        }
      }
    },
    NextSkill() {
      if (this.validate()) {
        //const skills = ["samtala", "beratta", "lyssna", "skriva", "lasa"];
        const levels = ["a1", "a2", "b1", "b2", "c1", "c2"];
        const oral = ["samtala", "beratta", "lyssna"];
        const writing = ["skriva", "lasa"];
        const basePath = "/assessment/" + this.type;
        if (
          this.levelResult < 4 &&
          this.result[this.skill].rough === this.level &&
          levels.indexOf(this.result[this.skill].rough) > 0
        ) {
		//reset questions
          window.alert(this.tooHigh[this.type][this.locale]);
	  this.result[this.skill][this.level] = [];

        } else {
          if (this.type === "D1") {
            if (this.improvements["level"]) {
              this.improvements["level"][this.skill] = this.level;
            } else {
              this.improvements["level"] = {};
              this.improvements["level"][this.skill] = this.level;
            }
            this.improvements[this.skill] = [];
            this.result[this.skill][this.level].forEach((res, index) => {
              if (res === "Nej") {
                this.improvements[this.skill].push(
                  this.assessment.assessment[this.skill][this.level][index]
                    .description
                );
              }
            });
          }
          if (this.part === "oral" || this.part === "both") {
            if (
              oral[oral.indexOf(this.skill) + 1] &&
              oral.includes(this.skill)
            ) {
              this.$router.push(
                basePath + "/" + oral[oral.indexOf(this.skill) + 1]
              );
            } else if (!this.continue && this.part !== "both") {
              this.continueDialog = true;
            } else {
              if (writing[writing.indexOf(this.skill) + 1]) {
                this.$router.push(
                  basePath + "/" + writing[writing.indexOf(this.skill) + 1]
                );
              } else if (this.skill === "lasa") {
                this.submitDialog = true;
              } else {
                this.$router.push(basePath + "/" + writing[0]);
              }
            }
          } else {
            if (
              writing[writing.indexOf(this.skill) + 1] &&
              writing.includes(this.skill)
            ) {
              this.$router.push(
                basePath + "/" + writing[writing.indexOf(this.skill) + 1]
              );
            } else if (!this.continue) {
              this.continueDialog = true;
            } else {
              if (oral[oral.indexOf(this.skill) + 1]) {
                this.$router.push(
                  basePath + "/" + oral[oral.indexOf(this.skill) + 1]
                );
              } else if (this.skill === "lyssna") {
                this.submitDialog = true;
              } else {
                this.$router.push(basePath + "/" + oral[0]);
              }
            }
          }
        }
      }
    },
    submit() {
      let date = new Date();
      // let authToken;
      // auth.currentUser.getIdToken().then(token => {
      //   authToken = token;
      // });
      let resultLang = "";

      if(this.locale === "en" || this.locale === "ar"){
	resultLang = "en";
      }else{
	resultLang = "sv";
      }
      const res = {
	lang: resultLang,
        type: this.type,
        locale: this.locale,
        result: this.result,
        improvements: this.type !== "D3" ? this.improvements : null,
        date: date.toLocaleString("sv", {
          day: "numeric",
          month: "numeric",
          year: "numeric"
        })
      };

      apiCall.post(FINISH_ASSESSMENT, { type: this.type }).then(response => {
        console.log(response)
        this.$store.dispatch('user/USER_REQUEST')
      }).catch(function() {})

      //const submitForm = functions.httpsCallable("submitForm");
      this.downloading = true;
      //submitForm(res).then(result => {
        //if (result) {
		//
          fetch(
            "https://europe-west1-oneandall-dev-9513d.cloudfunctions.net/getResult",
            {
              method: "POST",
              headers: {
                "Content-type": "application/json",
                // Authorization: "Bearer " + authToken
              },
              body: JSON.stringify(res)
            }
          )
            .then(res => {
              return res.blob();
            })
            .then(blob => {
              let filename = "";
              if (this.type === "D3") {
                filename = "result-" + this.result.contactInfo.tjänst + ".pdf";
              } else {
                filename = "result-" + this.result.contactInfo.email + ".pdf";
              }
              var url = window.URL.createObjectURL(blob);
              var a = document.createElement("a");
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
              this.downloading = false;
              this.$store.dispatch("user/LOGOUT");
              this.$router.push("/login");
            });
        /*} else {
          this.downloading = false;
          console.log("fel vid hämtning");
        }
      });*/
    },
    Prev() {
      if (this.skill) {
        this.$router.go(-1);
      }
    },
    validate() {
      const form = this.$refs.form;
      if (form.validate()) {
        return true;
      } else {
        const input = form.inputs.find(input => !input.valid);
        if (input.focus) {
          input.focus({ preventScroll: true });
        }
        this.$nextTick(() => {
          input.$el.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest"
          });
        });
      }
    },
    setPart(val) {
      this.part = val;
    },
    GetAssessment() {
      if (this.type) {
        db.collection("assessments")
          .where("type", "==", this.type)
          .where("lang", "==", this.locale)
          .get()
          .then(snapshot => {
            if (!snapshot.empty) {
              this.assessment = snapshot.docs[0].data();
              this.loading = false;
            }
          });
      }
    },
    preventNav(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    selectTypefunc(type) {
      this.type = type;
      this.GetAssessment();
      this.selectType = false;
    },
    isAdmin() {
      return this.$store.getters["user/IS_ADMIN"];
    },
  },
  watch: {
    locale() {
    if(this.locale === "ar" && this.fullPath !== "/assessment/D1" && this.fullPath !== "/assessment/D3"){
      this.$vuetify.rtl = true;
    }else{
      this.$vuetify.rtl = false;
    }
      this.GetAssessment();
    }
  },
  created() {
    /*
    this.isAdmin().then(admin => {
      this.admin = admin;
      if (
        (this.availableAssessments.D3 && this.availableAssessments.D1) ||
        this.admin
      ) {
        this.selectType = true;
      } else if (this.availableAssessments.D3) {
        if (this.availableAssessments.D3 > 0) {
          this.type = "D3";
          this.GetAssessment();
        }
      } else if (this.availableAssessments.D1) {
        if (this.availableAssessments.D1 > 0) {
          this.type = "D1";
          this.GetAssessment();
        }
      }
    });
    */
    this.GetAssessment();
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
  },
  beforeDestroy() {
	  // ta bort resultat
    window.removeEventListener("beforeunload", this.preventNav);
  }
};
</script>

<style lang="scss" scoped>
.lang-ar .action-buttons-container {
  direction: rtl !important;
}
</style>
